import { GetLabReportTextsTemplateResponse, LabClient, LabReportsTextsType, LabReportTextsTemplateEditModel, ReportTagModel } from '@app/api2/api';
import * as React from 'react';
import { Card, CardDescription, Form, Modal, ModalContent, ModalHeader, TextArea } from 'semantic-ui-react';
import { BPBoxWithHeader } from '@common/BPBoxWithHeader';
import { InfoBox } from '@common/InfoBox';

interface IReportTextTemplateProps {
    labId: number;
    readOnly?: boolean
    onReportTextTemplateChange?: (reportType: LabReportsTextsType, template: string) => any;
}

export const ReportTextTemplate: React.FunctionComponent<IReportTextTemplateProps> = (props) => {

    const [report, setReport] = React.useState<GetLabReportTextsTemplateResponse>()
    // const [reportTextTemplate, setReportTextTemplate] = React.useState('')
    // const [tags, setTags] = React.useState<{ [key in keyof typeof LabReportsTextsType]?: LabReportTextsTemplateEditModel; }>([])
    const [showHelp, setShowHelp] = React.useState(false)
    const [showPreview, setShowPreview] = React.useState(false)
    const [preview, setPreview] = React.useState('')
    const [helpTags, setHelpTags] = React.useState<ReportTagModel[]>()


    const labClient = new LabClient();

    React.useEffect(() => {
        async function fetch() {
            let reportTexts = await labClient.getReportTextsTemplate(props.labId);
            setReport(reportTexts)
            // setTags(reportTexts.reportTypes)
        }

        fetch()
    }, [])

    return <>
        {Object.keys(report?.reportTypes ?? {}).map(key => {
            return <BPBoxWithHeader header={key} buttons={[{
                label: window.translation.reportTexts.preview, action: async () => {
                    const res = await labClient.getReportTextsTemplatePreview(props.labId, report.reportTypes[key].template, key as any);
                    setPreview(res.preview)
                    setShowPreview(true)
                }
            }, {
                label: window.translation.reportTexts.help, action: async () => {
                    setHelpTags(report?.reportTypes[key]?.tags ?? {})
                    setShowHelp(true)
                }
            }]}>
                <Form as={'div'}>
                    {
                        <TextArea key={key} readOnly={props.readOnly} rows={20} value={report?.reportTypes[key]?.template} onChange={(ev, data) => {
                            if (!props.readOnly && props.onReportTextTemplateChange) {
                                setReport({ ...report, reportTypes: { ...report.reportTypes, [key]: { ...report.reportTypes[key], template: data.value.toString() } } })
                                props.onReportTextTemplateChange(key as any, data.value.toString())
                            }
                        }}></TextArea>

                    }
                </Form>
            </BPBoxWithHeader>
        })}
        <Modal open={showPreview} onClose={() => setShowPreview(false)} size={'large'} centered>
            <ModalHeader>
                {window.translation.reportTexts.preview}
            </ModalHeader>
            <ModalContent>
                <Form as={'div'}>
                    <TextArea value={preview} rows={20}></TextArea>
                </Form>
            </ModalContent>
        </Modal>
        <Modal open={showHelp} onClose={() => setShowHelp(false)} centered>
            <ModalHeader>
                {window.translation.reportTexts.help}
            </ModalHeader>
            <ModalContent>
                <InfoBox items={helpTags?.map(key => { return { label: key.tag, description: key.description } })} />
            </ModalContent>
        </Modal>
    </>
};

